import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  togglePassword(event) {
    const button = event.currentTarget;
    const input = button.closest(".relative").querySelector("input");
    const type = input.type === "password" ? "text" : "password";
    input.type = type;
  }
}
